import useSWR from 'swr'
import logger from '@crystal-eyes/utils/logger'

type EntryOption = 'mbti' | 'enneagram' | 'none'

type State = {
  entryState: {
    knowType: EntryOption
    setKnowType: (newValue: EntryOption) => void
  }
}

let sharedKnowType: EntryOption = 'none'
export default function useKnowYourType({}: object = {}): State {
  const { data: knowType, mutate: setKnowType } = useSWR(
    'useKnowType.knowType',
    () => {
      if (sharedKnowType !== 'none') logger.info('Know Type', sharedKnowType)
      return sharedKnowType
    },
    {
      keepPreviousData: true,
      revalidateOnFocus: false,
    },
  )

  return {
    entryState: {
      knowType: knowType || 'none',
      setKnowType: (newValue: EntryOption) => {
        sharedKnowType = newValue
        setKnowType(newValue)
      },
    },
  }
}
